import { useCallback, useEffect, useState, useRef } from "react";

export const useOpenMap = (tree, isLoading, isError) => {
  const [_update, setUpdate] = useState(0);
  const openMapRef = useRef(null);

  const update = useCallback(() => {
    setUpdate((prev) => prev + 1);
  }, []);

  const setOpenMap = useCallback((map) => {
    openMapRef.current = map;
  }, []);

  const toggleNode = useCallback(
    (nodeId) => {
      if (!nodeId) {
        return;
      }
      if (openMapRef.current && nodeId in openMapRef.current) {
        openMapRef.current[nodeId] = !openMapRef.current[nodeId];
        return;
      }
      if (openMapRef.current !== null) {
        openMapRef.current[nodeId] = false;
      }
    },
    [openMapRef],
  );

  useEffect(() => {
    if (openMapRef.current === null && tree && !isLoading && !isError) {
      const map = openMapRef.current ? { ...openMapRef.current } : {};
      calculateOpenMap(tree, map);

      openMapRef.current = map;
      update();
    }
  }, [tree, isLoading, isError, update, openMapRef]);

  // eslint-disable-next-line react-hooks/refs
  return { openMap: openMapRef.current, setOpenMap, toggleNode };
};

const calculateOpenMap = (treeNodes, map) => {
  const populateMap = (nodes) => {
    nodes.forEach((node) => {
      if (node.isWizard) {
        if (!(node.id in map)) {
          map[node.id] = false;
        }
      }

      if (Array.isArray(node.nodes) && node.nodes.length > 0) {
        populateMap(node.nodes);
      }
    });
  };

  populateMap(treeNodes);
};
